import styled from 'styled-components'
import {
  TokenPairImage as UIKitTokenPairImage,
  TokenPairImageProps as UIKitTokenPairImageProps,
  TokenImage as UIKitTokenImage,
  ImageProps,
  TokenLogo
} from '@pancakeswap/uikit'
import { variant as StyledSystemVariant } from "styled-system";
import { Token } from '@pancakeswap/sdk'
import { TokenLogoProps } from '@pancakeswap/uikit/src/components/TokenLogo/TokenLogo'
import { ChainId } from '@pancakeswap/chains'
import Wrapper from './Image/Wrapper'
import { Variant, variants } from './Image/types'


interface TokenPairImageProps extends Omit<UIKitTokenPairImageProps, 'primarySrc' | 'secondarySrc'> {
  primaryToken: Token
  secondaryToken: Token
}

export const tokenImageChainNameMapping = {
  [ChainId.BSC]: '',
  [ChainId.ETHEREUM]: 'eth/',
  [ChainId.POLYGON_ZKEVM]: 'polygon-zkevm/',
  [ChainId.ZKSYNC]: 'zksync/',
  [ChainId.ARBITRUM_ONE]: 'arbitrum/',
  [ChainId.LINEA]: 'linea/',
  [ChainId.BASE]: 'base/',
}

interface StyledImageProps extends TokenLogoProps {
  variant: Variant;
}

const StyledPrimaryImage = styled(TokenLogo) <StyledImageProps>`
  position: absolute;
  width: ${({ variant }) =>
    variant === variants.DEFAULT ? "92%" : "82%"}; // 92, 82 are arbitrary numbers to fit the variant

  ${StyledSystemVariant({
      variants: {
        [variants.DEFAULT]: {
          bottom: "auto",
          left: 0,
          right: "auto",
          top: 0,
          zIndex: 5,
        },
        [variants.INVERTED]: {
          bottom: 0,
          left: "auto",
          right: 0,
          top: "auto",
          zIndex: 6,
        },
      },
    })}
`;

const StyledSecondaryImage = styled(TokenLogo) <StyledImageProps>`
  position: absolute;
  width: 50%;

  ${StyledSystemVariant({
  variants: {
    [variants.DEFAULT]: {
      bottom: 0,
      left: "auto",
      right: 0,
      top: "auto",
      zIndex: 6,
    },
    [variants.INVERTED]: {
      bottom: "auto",
      left: 0,
      right: "auto",
      top: 0,
      zIndex: 5,
    },
  },
})}
`;

const getImageUrlFromToken = (token: Token) => {
  const address = token?.isNative ? token.wrapped.address : token.address

  return `https://tokens.pre-prod.v3-cbr.pages.dev/images/${tokenImageChainNameMapping[token.chainId]}${address}.png`
}

const getImageUrlsFromToken = (token: Token) => {
  return [`/assets/symbols/${token.symbol.toLowerCase()}.png`]
}

export const TokenPairImage: React.FC<React.PropsWithChildren<TokenPairImageProps>> = ({
  primaryToken,
  secondaryToken,
  variant = variants.DEFAULT,
  ...props
}) => {
  const primarySrcs = getImageUrlsFromToken(primaryToken)
  const secondarySrcs = getImageUrlsFromToken(secondaryToken)
  console.log('primarySrcs', primarySrcs)
  console.log('secondarySrcs', secondarySrcs)
  return (
    <Wrapper position="relative" {...props}>
      <StyledPrimaryImage variant={variant} srcs={primarySrcs} {...props} />
      <StyledSecondaryImage variant={variant} srcs={secondarySrcs} {...props} style={{ minWidth: 0 }} />
    </Wrapper>
  )
  // return (
  //   <UIKitTokenPairImage
  //     // primarySrc={getImageUrlFromToken(primaryToken)}
  //     primarySrc={undefined}
  //     secondarySrc={getImageUrlFromToken(secondaryToken)}
  //     primaryImageProps={{
  //       srcSet: getImageUrlsFromToken(primaryToken)
  //     }}
  //     {...props}
  //   />
  // )
}

interface TokenImageProps extends ImageProps {
  token: Token
}

export const TokenImage: React.FC<React.PropsWithChildren<TokenImageProps>> = ({ token, ...props }) => {
  return <UIKitTokenImage src={getImageUrlFromToken(token)} {...props} />
}
